"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/style/IconAnchorUnits
 */

/**
 * Icon anchor units. One of 'fraction', 'pixels'.
 * @enum {string}
 */
var _default = {
  /**
   * Anchor is a fraction
   * @api
   */
  FRACTION: 'fraction',

  /**
   * Anchor is in pixels
   * @api
   */
  PIXELS: 'pixels'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7ZUFJZTtFQUNiOzs7O0VBSUFBLFFBQVEsRUFBRSxVQUxHOztFQU1iOzs7O0VBSUFDLE1BQU0sRUFBRTtBQVZLLEMiLCJuYW1lcyI6WyJGUkFDVElPTiIsIlBJWEVMUyJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvc3R5bGUvSWNvbkFuY2hvclVuaXRzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19